(() => {
  'use strict';
  const dialogTriggers = new WeakMap();
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    dialogTriggers.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    const input = dialog.querySelector('input:not([type="hidden"]),button,a');
    input?.focus();
    if (trigger?.matches('.menu-open')) trigger.setAttribute('aria-expanded', 'true');
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    const trigger = dialogTriggers.get(dialog);
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-dialog],.menu-open');
    if (opener) openDialog(document.getElementById(opener.dataset.openDialog || 'mobile-menu'), opener);
    const closer = event.target.closest('.dialog-close');
    if (closer) closeDialog(closer.closest('dialog'));
    const toggle = event.target.closest('.submenu-toggle');
    if (toggle) {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      toggle.parentElement.classList.toggle('expanded', !expanded);
      toggle.textContent = expanded ? '+' : '−';
    }
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('cancel', () => {
      const trigger = dialogTriggers.get(dialog);
      trigger?.setAttribute('aria-expanded', 'false');
    });
  });
  document.querySelectorAll('[data-slideshow]').forEach(slideshow => {
    const slides = [...slideshow.querySelectorAll('.editorial-slide')];
    if (slides.length < 2) return;
    let index = 0, timer = null, paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pauseButton = slideshow.querySelector('.slide-pause');
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.inert = i !== index;
      });
    };
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => {
      stop();
      if (!paused && !document.hidden) timer = setInterval(() => show(index + 1), Number(slideshow.dataset.interval) || 5000);
    };
    slideshow.querySelector('.slide-next')?.addEventListener('click', () => { show(index + 1); start(); });
    slideshow.querySelector('.slide-prev')?.addEventListener('click', () => { show(index - 1); start(); });
    pauseButton?.addEventListener('click', () => { paused = !paused; pauseButton.textContent = paused ? 'Play slideshow' : 'Pause slideshow'; pauseButton.setAttribute('aria-label', pauseButton.textContent); start(); });
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    show(0); start();
  });
  document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
    const option = select.selectedOptions[0], section = select.closest('[data-product-section]');
    const price = section.querySelector('[data-product-price]'), button = section.querySelector('[data-add-button]');
    if (price) price.textContent = option.dataset.price;
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to cart'; }
    const compare = section.querySelector('[data-compare-price]');
    if (compare) compare.hidden = true;
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
    const media = document.getElementById('Media-' + option.dataset.media);
    if (media) media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }));
  document.querySelectorAll('.product-thumbnails a').forEach(link => link.addEventListener('click', event => {
    const media = document.getElementById(link.hash.slice(1));
    if (media) { event.preventDefault(); media.scrollIntoView({ behavior:'smooth', block:'nearest', inline:'start' }); }
  }));
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[data-policy-dialog]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const dialog = document.getElementById('policy-dialog'), content = dialog?.querySelector('.policy-body');
    if (!dialog || !content) return;
    event.preventDefault();
    content.textContent = 'Loading…'; openDialog(dialog, link);
    try {
      const response = await fetch(url.href, { credentials:'same-origin' });
      if (!response.ok) throw new Error('Unable to load information.');
      const page = new DOMParser().parseFromString(await response.text(),'text/html');
      const body = page.querySelector('.shopify-policy__container,.content-page,main');
      if (!body) throw new Error('Unable to load information.');
      body.querySelectorAll('script,style,iframe').forEach(node => node.remove());
      content.replaceChildren(...[...body.childNodes].map(node => document.importNode(node,true)));
    } catch {
      content.textContent = 'This information could not be loaded. ';
      const fallback = document.createElement('a'); fallback.href = link.href; fallback.textContent = 'Open the page'; content.append(fallback);
    }
  });
})();
/* Match native option radios to genuine Shopify variant IDs. */
document.querySelectorAll('[data-product-section]').forEach(section => {
  const select = section.querySelector('[data-variant-select]');
  const data = section.querySelector('[data-product-variants]');
  if (!select || !data) return;
  let variants;
  try { variants = JSON.parse(data.textContent); } catch { return; }
  section.classList.add('js-variant-ready');
  const updateSku = () => {
    const variant = variants.find(item => String(item.id) === select.value);
    const sku = section.querySelector('[data-product-sku]');
    if (sku) sku.textContent = variant?.sku ? 'SKU: ' + variant.sku : '';
  };
  section.querySelectorAll('.variant-options input[type="radio"]').forEach(radio => radio.addEventListener('change', () => {
    const values = [...section.querySelectorAll('.variant-options fieldset')].map(fieldset => fieldset.querySelector('input:checked')?.value);
    const variant = variants.find(item => item.options.every((value, index) => value === values[index]));
    const button = section.querySelector('[data-add-button]');
    if (variant) {
      select.value = String(variant.id);
      select.dispatchEvent(new Event('change', { bubbles:true }));
    } else if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
  }));
  select.addEventListener('change', updateSku);
});

// Quantity buttons update the native product quantity field.
document.addEventListener('click', event => {
  const button = event.target.closest('[data-quantity-step]');
  if (!button) return;
  const input = button.closest('.quantity-control')?.querySelector('input[name="quantity"]');
  if (!input) return;
  if (Number(button.dataset.quantityStep) > 0) input.stepUp(); else if (Number(input.value) > Number(input.min || 1)) input.stepDown();
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// Group gallery media using the source variant-title alt metadata when available.
document.querySelectorAll('[data-product-section]').forEach(section => {
  const select = section.querySelector('[data-variant-select]');
  const data = section.querySelector('[data-product-variants]');
  if (!select || !data) return;
  let variants;
  try { variants = JSON.parse(data.textContent); } catch { return; }
  const titles = new Set(variants.map(variant => variant.title));
  const update = (scroll) => {
    const variant = variants.find(item => String(item.id) === select.value);
    if (!variant) return;
    section.querySelectorAll('[data-media-alt]').forEach(item => {
      const group = item.dataset.mediaAlt;
      item.hidden = titles.has(group) && group !== variant.title;
    });
    if (scroll) {
      const mediaId = select.selectedOptions[0]?.dataset.media;
      const featured = mediaId ? document.getElementById('Media-' + mediaId) : null;
      const target = featured && !featured.hidden ? featured : section.querySelector('.product-media:not([hidden])');
      target?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
  };
  select.addEventListener('change', () => update(true));
  update(false);
});
